export const HEADING_KEYS = [
  ["productName", "Product Name"], ["brandName", "Brand"], ["gazetteNo", "Gazette No."], ["gazetteDate", "Gazette Date"],
  ["serialNo", "Serial No."], ["composition", "Composition"], ["specifications", "Specifications"], ["dosage", "Recommended Dosage & Crops"],
  ["contact", "Company Contact"],
];

export const TRANSLATABLE = ["productName", "brandName", "composition", "specifications", "dosage"];

export const DEFAULT_LANGUAGES = [
  { code: "kn", name: "ಕನ್ನಡ / Kannada", order: 1 },
  { code: "te", name: "తెలుగు / Telugu", order: 2 },
  { code: "ta", name: "தமிழ் / Tamil", order: 3 },
  { code: "hi", name: "हिन्दी / Hindi", order: 4 },
  { code: "mr", name: "मराठी / Marathi", order: 5 },
  { code: "gu", name: "ગુજરાતી / Gujarati", order: 6 },
  { code: "or", name: "ଓଡ଼ିଆ / Odia", order: 7 },
  { code: "bn", name: "বাংলা / Bengali", order: 8 },
  { code: "ur", name: "اردو / Urdu", order: 9 },
  { code: "ml", name: "മലയാളം / Malayalam", order: 10 },
].map((l) => ({ ...l, visible: true }));

export const RTL_CODES = ["ur", "ar", "fa", "he", "sd", "ks"];
export const dirFor = (code) => (RTL_CODES.includes(String(code).split("-")[0]) ? "rtl" : "ltr");

export const DEFAULT_HEADINGS = {
  en: Object.fromEntries(HEADING_KEYS),
  kn: {
    productName: "ಉತ್ಪನ್ನದ ಹೆಸರು", brandName: "ಬ್ರಾಂಡ್", gazetteNo: "ಗೆಜೆಟ್ ಸಂಖ್ಯೆ", gazetteDate: "ಗೆಜೆಟ್ ದಿನಾಂಕ",
    serialNo: "ಕ್ರಮ ಸಂಖ್ಯೆ", composition: "ಸಂಯೋಜನೆ", specifications: "ವಿಶೇಷತೆಗಳು", dosage: "ಶಿಫಾರಸು ಮಾಡಿದ ಪ್ರಮಾಣ ಮತ್ತು ಬೆಳೆಗಳು", contact: "ಸಂಪರ್ಕ",
  },
  te: {
    productName: "ఉత్పత్తి పేరు", brandName: "బ్రాండ్", gazetteNo: "గెజిట్ సంఖ్య", gazetteDate: "గెజిట్ తేదీ",
    serialNo: "క్రమ సంఖ్య", composition: "కూర్పు", specifications: "ప్రత్యేకతలు", dosage: "సిఫార్సు చేసిన మోతాదు & పంటలు", contact: "సంప్రదించండి",
  },
  ta: {
    productName: "தயாரிப்பு பெயர்", brandName: "பிராண்ட்", gazetteNo: "அரசிதழ் எண்", gazetteDate: "அரசிதழ் தேதி",
    serialNo: "வரிசை எண்", composition: "கலவை", specifications: "விவரக்குறிப்புகள்", dosage: "பரிந்துரைக்கப்பட்ட அளவு & பயிர்கள்", contact: "தொடர்புக்கு",
  },
  hi: {
    productName: "उत्पाद का नाम", brandName: "ब्रांड", gazetteNo: "राजपत्र संख्या", gazetteDate: "राजपत्र तिथि",
    serialNo: "क्रम संख्या", composition: "संरचना", specifications: "विशिष्टताएँ", dosage: "अनुशंसित खुराक एवं फसलें", contact: "संपर्क",
  },
  mr: {
    productName: "उत्पादनाचे नाव", brandName: "ब्रँड", gazetteNo: "राजपत्र क्रमांक", gazetteDate: "राजपत्र दिनांक",
    serialNo: "अनुक्रमांक", composition: "घटक", specifications: "वैशिष्ट्ये", dosage: "शिफारस केलेली मात्रा व पिके", contact: "संपर्क",
  },
  gu: {
    productName: "ઉત્પાદનનું નામ", brandName: "બ્રાન્ડ", gazetteNo: "ગેઝેટ નંબર", gazetteDate: "ગેઝેટ તારીખ",
    serialNo: "ક્રમ નંબર", composition: "રચના", specifications: "વિશિષ્ટતાઓ", dosage: "ભલામણ કરેલ માત્રા અને પાક", contact: "સંપર્ક",
  },
  or: {
    productName: "ଉତ୍ପାଦର ନାମ", brandName: "ବ୍ରାଣ୍ଡ", gazetteNo: "ଗେଜେଟ୍ ନମ୍ବର", gazetteDate: "ଗେଜେଟ୍ ତାରିଖ",
    serialNo: "କ୍ରମିକ ନମ୍ବର", composition: "ଗଠନ", specifications: "ବିଶେଷତ୍ୱ", dosage: "ସୁପାରିଶ କରାଯାଇଥିବା ମାତ୍ରା ଓ ଫସଲ", contact: "ଯୋଗାଯୋଗ",
  },
  bn: {
    productName: "পণ্যের নাম", brandName: "ব্র্যান্ড", gazetteNo: "গেজেট নম্বর", gazetteDate: "গেজেট তারিখ",
    serialNo: "ক্রমিক নম্বর", composition: "উপাদান", specifications: "বৈশিষ্ট্য", dosage: "প্রস্তাবিত মাত্রা ও ফসল", contact: "যোগাযোগ",
  },
  ur: {
    productName: "مصنوعات کا نام", brandName: "برانڈ", gazetteNo: "گزٹ نمبر", gazetteDate: "گزٹ تاریخ",
    serialNo: "سیریل نمبر", composition: "ترکیب", specifications: "خصوصیات", dosage: "تجویز کردہ خوراک اور فصلیں", contact: "رابطہ",
  },
  ml: {
    productName: "ഉൽപ്പന്നത്തിന്റെ പേര്", brandName: "ബ്രാൻഡ്", gazetteNo: "ഗസറ്റ് നമ്പർ", gazetteDate: "ഗസറ്റ് തീയതി",
    serialNo: "ക്രമ നമ്പർ", composition: "ഘടന", specifications: "സവിശേഷതകൾ", dosage: "ശുപാർശ ചെയ്യുന്ന അളവും വിളകളും", contact: "ബന്ധപ്പെടുക",
  },
};

const clean = (obj) =>
  Object.fromEntries(Object.entries(obj || {}).filter(([, v]) => typeof v === "string" && v.trim()).map(([k, v]) => [k, v.trim()]));

export const headingsFor = (code, stored) => ({ ...DEFAULT_HEADINGS.en, ...DEFAULT_HEADINGS[code], ...clean(stored?.[code]) });

export const sortLanguages = (langs) =>
  [...langs].sort((a, b) => (a.order ?? 0) - (b.order ?? 0)).map((l) => ({ ...l, visible: l.visible !== false }));

export const shortName = (name) => name.split("/")[0].trim();

export function buildBlocks(product, settings) {
  const blocks = [{ code: "en", name: "English", headings: headingsFor("en", settings.headings), data: product }];
  for (const lang of settings.languages || []) {
    const t = clean(product.translations?.[lang.code]);
    if (lang.code === "en" || lang.visible === false || !TRANSLATABLE.some((k) => t[k])) continue;
    blocks.push({
      code: lang.code, name: lang.name, headings: headingsFor(lang.code, settings.headings),
      data: { ...t, productName: t.productName || product.productName, brandName: t.brandName || product.brandName },
    });
  }
  return blocks;
}
